module.exports = __webpack_public_path__ + "static/media/commercial-vehicle-details-large.4506dba8.png";